/** Add responsive candidates to known CMS card slots, using existing R2
 * derivatives only. Explicit author srcsets and loading choices win. */
export function responsiveCmsImages(html: string, identifier: string): string {
  const serviceCard = /^why_choose_us_block_\d+$/.test(identifier);
  if (!serviceCard && identifier !== 'homepage_promotion') return html;
  const sizes = serviceCard
    ? '(max-width: 768px) calc(100vw - 58px), (max-width: 1200px) 45vw, 400px'
    : '(max-width: 768px) calc(100vw - 40px), (max-width: 1200px) 50vw, 600px';
  return html.replace(/<img\b[^>]*>/gi, tag => {
    if (/\bsrcset\s*=/i.test(tag)) return tag;
    const src = tag.match(/\bsrc\s*=\s*(["'])([^"']+)\1/i);
    if (!src || !/\/cdn\/.+\/\d+\.webp(?:[?#]|$)/.test(src[2])) return tag;
    const rendition = (width: number) => src[2].replace(/\/\d+\.webp(?=[?#]|$)/, `/${width}.webp`);
    const srcset = [320, 400, 500, 600, 640, 700, 768, 800, 960, 1280].map(w => `${rendition(w)} ${w}w`).join(', ');
    const out = tag.replace(src[0], `src=${src[1]}${rendition(600)}${src[1]}`);
    const attrs = ` srcset="${srcset}" sizes="${sizes}"`
      + (serviceCard && !/\bloading\s*=/i.test(tag) ? ' loading="lazy"' : '')
      + (!/\bdecoding\s*=/i.test(tag) ? ' decoding="async"' : '');
    return out.replace(/\s*\/?>$/, end => attrs + end);
  });
}
